import { Dialog, DialogContent, ListItem, ListItemText } from '@material-ui/core';
import { uniqueId } from 'lodash';
import { FC, ReactNode, SyntheticEvent, useState } from 'react';
import T from 'src/components/content-manager/translator/T';
import DialogTitleWithClose from 'src/components/elements/DialogTitleWithClose';
import { VolumeDiscountTabs } from './VolumeDiscountTabs';

interface VolumeDiscountDiscoverProps {
    trigger?: (onClick: (e: SyntheticEvent) => void) => ReactNode;
}

export const VolumeDiscountDiscover: FC<VolumeDiscountDiscoverProps> = ({ trigger }) => {
    const [open, setOpen] = useState(false);
    const id = uniqueId('dialog');

    const handleOpen = (e: SyntheticEvent) => {
        setOpen(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {trigger ? (
                trigger(handleOpen)
            ) : (
                <ListItem button onClick={handleOpen}>
                    <ListItemText>
                        <T k="shop.volume_discount_discover.action" />
                    </ListItemText>
                </ListItem>
            )}
            <Dialog
                disableEscapeKeyDown
                onClose={handleClose}
                aria-labelledby={id}
                open={open}
                maxWidth="lg"
                onClick={e => e.stopPropagation()}>
                <DialogTitleWithClose onClose={handleClose} id={id} />
                <DialogContent>
                    <VolumeDiscountTabs />
                </DialogContent>
            </Dialog>
        </>
    );
};
